import { render } from "./EditPriceNumDialog.vue?vue&type=template&id=5855a96f"
import script from "./EditPriceNumDialog.vue?vue&type=script&lang=js"
export * from "./EditPriceNumDialog.vue?vue&type=script&lang=js"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__